export default __webpack_public_path__ + "static/media/icon_myresources.caac40e1.png";